/** Static copy for deciding a job with charges and for its decision history. */
export const CLAIM_ITEM_DECISION_CONFIG = {
  otherCoverage: 'Other',
  someone: 'Someone',
  version: 'Version',
  sentBackToDraft: 'Sent back to draft',
  noEligibilityLimit: 'No eligibility limit applies to this job yet.',
  notClaimAuthorization: "Approving a job doesn't authorize the claim for payment.",

  labels: {
    outcome: 'Outcome',
    requested: 'Requested',
    authorized: 'Authorized',
    difference: 'Difference',
    coverage: 'Coverage',
    deductible: 'Deductible',
    limit: 'Limit',
    eligibility: 'Eligibility',
    decidedBy: 'Decided By',
    status: 'Status',
    reason: 'Reason',
    note: 'Note',
    details: 'Details',
  },

  history: {
    latestTitle: 'Latest Decision',
    title: 'Decision History',
    beforeTax: 'Amounts are before tax.',
  },

  form: {
    included: 'Included',
    excluded: 'Excluded',
    reviewing: 'Reviewing',
    loading: 'Loading charges...',
    loadFailed: "We couldn't load what's needed to adjudicate this job. Close and reopen to try again.",
    resolved: "This job is resolved, so its decision can't be changed.",
    amountHint: "Each authorized amount must be in whole cents, between $0.00 and that charge's requested amount.",
    reasonPlaceholder: 'Select a reason',
    rejectNote: "Rejecting sets every charge's authorized amount to $0.00.",
    notePlaceholder: 'Optionally add a note on why this job is going back to review.',
    detailsPlaceholder: 'Optionally add details for this decision.',

    columns: {
      type: 'Type',
      description: 'Description',
      requested: 'Requested',
      authorized: 'Authorized $',
    },
  },

  // Why Save is off, shown on hover like the other item steps. Plain strings are titles for copy kept elsewhere.
  saveBlocked: {
    loading: 'Loading',
    loadFailed: 'Not Loaded',
    resolved: 'Item Resolved',
    openHolds: 'Open Holds',
    amounts: 'Check Amounts',
    saving: { title: 'Saving', subtitle: 'Saving this decision...' },
    charges: {
      title: 'Charges Needed',
      subtitle: 'Add a charge on the Details step before approving this claim item. It can still be rejected.',
    },
    checkingEligibility: {
      title: 'Checking Eligibility',
      subtitle: 'Wait for the eligibility check to finish before approving this claim item.',
    },
    notEligible: {
      title: 'Not Eligible',
      subtitle: 'The eligibility check above blocks this approval. See its message for what to do.',
    },
    reasoning: {
      title: 'Reason Needed',
      subtitle: 'Enter the reasoning for approving or rejecting this claim item.',
    },
    reasonPick: {
      title: 'Reason Needed',
      subtitle: 'Select a reason for this decision.',
    },
  },

  toasts: {
    approved: (coverage: string) => ({
      title: `${coverage} Item Approved`,
      text: `The ${coverage} item has been successfully adjudicated as approved.`,
    }),
    rejected: (coverage: string) => ({
      title: `${coverage} Item Rejected`,
      text: `The ${coverage} item has been successfully adjudicated as rejected.`,
    }),
    redrafted: (coverage: string) => ({
      title: `${coverage} Item Redrafted`,
      text: `The ${coverage} item has been successfully set as draft.`,
    }),
    conflict: {
      title: 'Decision changed',
      text: "Someone else changed this job's decision. Reload to see the latest before trying again.",
    },
    errorTitle: 'Something went wrong',
  },
} as const;
